import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import "../../../../App.css"
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, Table, DropdownButton } from 'react-bootstrap';
import { getDocument, getCourse, AssignDocument, getAllCourseDocuments, updateDocumentsForCourse } from '../../../api/coursewisedocument';
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function CourseWiseDocument() {
    const [error, setError] = useState('');
    const [documents, setDocuments] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [courses, setCourses] = useState([]);
    const [isMandatory, setIsMandatory] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [courseDocument, setCourseDocument] = useState([]);

    const [isEditing, setIsEditing] = useState(false);
    const [currentCourseId, setCurrentCourseId] = useState(null);
    const [currentDocumentIds, setCurrentDocumentIds] = useState([]);
    const [errors, setErrors] = useState({});
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [doc, coursesRes, courseDocResponse] = await Promise.all([
                    getDocument(token),
                    getCourse(token),
                    getAllCourseDocuments(token),
                ]);
                setDocuments(doc.data);
                setCourses(coursesRes.data)
                console.log("Document", doc.data);
                console.log("Course docs response:", courseDocResponse.data)
                setCourseDocument(courseDocResponse.data);
            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);

    const handleCourseChange = (e) => {
        const courseId = e.target.value;
        setSelectedCourse((prevSelected) =>
            prevSelected.includes(courseId)
                ? prevSelected.filter((id) => id !== courseId)
                : [...prevSelected, courseId]
        );
        setErrors((prev) => ({ ...prev, selectedCourse: "" }));
    };

    const handleDocumentChange = (e) => {
        const documentId = e.target.value;
        setSelectedDocument((prevSelected) =>
            prevSelected.includes(documentId)
                ? prevSelected.filter((id) => id !== documentId)
                : [...prevSelected, documentId]
        );
        setErrors((prev) => ({ ...prev, selectedDocument: "" }));
    };

    const handleEditClick = (courseId, documents, mandatory, active) => {
        setIsEditing(true);
        setCurrentCourseId(courseId);
        setSelectedCourse([String(courseId)]);
        setSelectedDocument(documents.map((doc) => String(doc.id)));
        setIsMandatory(mandatory);
        setIsActive(active);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};
        if (selectedCourse.length === 0) {
            newErrors.selectedCourse = "Please select at least one course.";
        }
        if (selectedDocument.length === 0) {
            newErrors.selectedDocument = "Please select at least one document.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }


        const assignmentDTO = {
            documentIds: selectedDocument.map((id) => parseInt(id)),
            isMandatory: isMandatory,
            isActive: isActive,
        };

        try {
            if (isEditing) {
                await updateDocumentsForCourse(currentCourseId, token, assignmentDTO);
                toast.success("Documents updated successfully!");
            } else {
                for (const courseId of selectedCourse) {
                    await AssignDocument(courseId, assignmentDTO, token);
                }
                toast.success("Documents assigned successfully!");
            }
            handleCancel();

            const updatedCourseDocs = await getAllCourseDocuments(token);
            setCourseDocument(updatedCourseDocs.data);
        } catch (error) {
            console.error("Error assigning documents:", error);
            toast.error("Failed to assign documents.");
        }
    };

    const handleCancel = () => {
        setSelectedCourse([]);
        setSelectedDocument([]);
        setIsMandatory(false);
        setIsActive(false);
        setErrors({});
        setIsEditing(false);
    }

    const groupedByCourse = courseDocument?.reduce((acc, doc) => {
        const courseName = doc.course.courseName;
        const documentName = doc.document.certificateName;

        if (!acc[courseName]) {
            acc[courseName] = [];
        }
        acc[courseName].push({
            id: doc.document.id, name: documentName, isMandatory: doc.isMandatory,
            isActive: doc.isActive
        });

        return acc;
    }, {});


    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Course-Wise Document</p>
                        <Form>
                            <Row className='mt-4'>
                                <Row className="mb-3">
                                    <Form.Label
                                        className="col-sm-3 col-form-label form-label"
                                        htmlFor="courseDropdown"
                                    >
                                        Course<span className="text-danger">*</span>
                                    </Form.Label>
                                    <Col sm={7} className="mb-3 mb-lg-0">
                                        <DropdownButton
                                            title={
                                                selectedCourse.length > 0
                                                    ? courses
                                                        .filter((course) => selectedCourse.includes(String(course.id)))
                                                        .map((course) => course.courseName)
                                                        .join(", ")
                                                    : "Select Course"
                                            }
                                            id="course-dropdown"
                                            className="course-dropdown"
                                        >
                                            <div style={{ padding: '10px' }}>
                                                {courses.map((course) => (
                                                    <Form.Check
                                                        key={course.id}
                                                        type="checkbox"
                                                        id={`course - ${course.id}`}
                                                        value={course.id}
                                                        label={course.courseName}
                                                        checked={selectedCourse.includes(String(course.id))} 
                                                        onChange={handleCourseChange}
                                                    />

                                                ))}
                                            </div>
                                        </DropdownButton>
                                        {errors.selectedCourse && (
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "13px",
                                                    marginTop: "3px",
                                                }}
                                            >
                                                {errors.selectedCourse}
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Label
                                        className="col-sm-3 col-form-label form-label"
                                        htmlFor="fullName"
                                    >
                                        Document<span className="text-danger">*</span>
                                    </Form.Label>

                                    <Col sm={7} className="mb-3 mb-lg-0">
                                        <DropdownButton
                                            title={
                                                selectedDocument.length > 0
                                                    ? documents
                                                        .filter((document) => selectedDocument.includes(String(document.id)))
                                                        .map((document) => document.certificateName)
                                                        .join(", ")
                                                    : "Select Document"
                                            }
                                            id="course-dropdown"
                                            className="course-dropdown"
                                        >
                                            <div style={{ padding: '10px' }}>
                                                {documents.map((document) => (
                                                    <Form.Check
                                                        key={document.id}
                                                        type="checkbox"
                                                        id={`document - ${document.id}`}
                                                        value={document.id}
                                                        label={document.certificateName}
                                                        checked={selectedDocument.includes(String(document.id))} 
                                                        onChange={handleDocumentChange}
                                                    />

                                                ))}
                                            </div>
                                        </DropdownButton>
                                        {errors.selectedDocument && (
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "13px",
                                                    marginTop: "3px",
                                                }}
                                            >
                                                {errors.selectedDocument}
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Label
                                        className="col-sm-3 col-form-label form-label"
                                        htmlFor="fullName"
                                    >
                                        Mandatory
                                    </Form.Label>
                                    <Col sm={7} className="mb-3 mb-lg-0">
                                        <Form.Check
                                            type="checkbox"
                                            id="mandatoryCheckbox"
                                            label="Check if mandatory"
                                            checked={isMandatory}
                                            onChange={(e) =>
                                                setIsMandatory(e.target.checked)
                                            }
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Form.Label
                                        className="col-sm-3 col-form-label form-label"
                                        htmlFor="fullName"
                                    >
                                        Active
                                    </Form.Label>
                                    <Col sm={7} className="mb-3 mb-lg-0">
                                        <Form.Check
                                            type="checkbox"
                                            id="activeCheckbox"
                                            label="Check if active"
                                            checked={isActive}
                                            onChange={(e) => setIsActive(e.target.checked)}
                                        />
                                    </Col>
                                </Row>
                            </Row>
                            <Row className="align-items-center">
                                <Col className="d-flex align-items-center justify-content-center">
                                    <Button variant="primary" type="submit" onClick={handleSubmit}>
                                        {isEditing ? "Update" : "Submit"}
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="reset" style={{ marginLeft: '10px' }} onClick={handleCancel}>
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>

                <Card className="mt-4">
                    <Card.Body>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Action</th>
                                    <th>Course</th>
                                    <th>Document</th>
                                    <th>Mandatory</th>
                                    <th>Active</th>
                                </tr>
                            </thead>
                            <tbody>

                                {groupedByCourse && Object.entries(groupedByCourse).map(([courseName, docs]) => (
                                    <tr key={courseName}>
                                        <td>
                                            <Button
                                                variant="secondary"
                                                onClick={() => {
                                                    const courseId = courses.find(course => course.courseName === courseName)?.id;
                                                    handleEditClick(courseId, docs, docs[0]?.isMandatory,
                                                        docs[0]?.isActive);
                                                }}
                                            >
                                                <i className="bi bi-pencil-fill me-2" /> Edit
                                            </Button>
                                        </td>
                                        <td>{courseName}</td>
                                        <td>{docs.map(doc => doc.name).join(", ")}</td>
                                        <td>
                                            {docs[0]?.isMandatory ? "Yes" : "No"}
                                        </td>
                                        <td>{docs[0]?.isActive ? "Yes" : "No"}</td>
                                    </tr>
                                ))}
                            </tbody>

                        </Table>
                    </Card.Body>
                </Card>
            </div>

        </>
    );
}

export default CourseWiseDocument; 
